import React from 'react';
import PropTypes from 'prop-types';
import { SparkleCross, SparkleCurved, SparkleMain } from './aiDefaultSparkle';
import { StyledIconWrapper, StyledSparkleContainer } from './styles';

/**
 * NikeAI Icon Component
 * Renders Nike AI sparkle icon
 *
 * @param {Object} props
 * @param {string} props.ariaLabel - Accessible label for the icon
 * @returns {React.ReactElement}
 */
const IconNikeAI = ({ ariaLabel = 'Nike AI' }) => {
  return (
    <StyledIconWrapper aria-label={ariaLabel} data-name="Nike AI Icon" role="img">
      <StyledSparkleContainer position="sparkle1">
        <SparkleMain />
      </StyledSparkleContainer>
      <StyledSparkleContainer position="sparkle2">
        <SparkleCurved />
      </StyledSparkleContainer>
      <StyledSparkleContainer position="sparkle3">
        <SparkleCross />
      </StyledSparkleContainer>
    </StyledIconWrapper>
  );
};

IconNikeAI.propTypes = {
  ariaLabel: PropTypes.string,
};

IconNikeAI.defaultProps = {
  ariaLabel: 'Nike AI',
};

export default IconNikeAI;
